import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field } from 'redux-form/immutable';

import messages from '../messages';
import { SimpleInput, Checkbox, SelectInput } from '../field-components';
import { required, validateTin } from '../validators';
import { Api } from '../api';
import { toast } from 'react-toast';

export default class Entrepreneur extends React.Component {
  state = {
    checked: this.props.isJuridicalChecked || false,
    juridicalList: [],
    loading: false,
  };

  componentDidMount() {
    if (window.user) {
      Api.fetchJuridicalList().then((resp) => {
        this.setState({ juridicalList: JSON.parse(resp.body) });
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.isJuridicalChecked !== this.props.isJuridicalChecked) {
      this.setState({ checked: this.props.isJuridicalChecked });
    }
  }

  handleCheck = () => this.setState({ checked: !this.state.checked });

  handleError = (error) => {
    console.log(error.response || error);

    if (error.response) {
      if (error.response.status === 422) {
        return Object.values(error.response.body).forEach((err) =>
          toast(err[0], { backgroundColor: '#f2dede', color: '#a94442' })
        );
      }
      const message = error.response.body ? error.response.body.message : error.response.message;
      return toast(message, { backgroundColor: '#f2dede', color: '#a94442' });
    }

    return toast(error.message, { backgroundColor: '#f2dede', color: '#a94442' });
  };

  sendTin = (tin, cb, errorCb) => {
    this.setState({ loading: true });
    return Api.sendTin({ tin, pin_fl: window.user.pin_fl })
      .then((res) => cb(res))
      .catch((err) => {
        this.handleError(err);

        if (errorCb) {
          errorCb(err);
        }
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleClick = () => {
    this.sendTin(this.props.tin, (res) => {
      if (res.ok && res.body.status) {
        console.log(res);
        this.props.change(`${this.props.formName}[juridical_name]`, res.body.juridical_name);
      } else {
        this.handleError(res.body);
      }
    });
  };

  handleChange = (e) => {
    if (e.target.value) {
      const organization = this.state.juridicalList.find((org) => org.id === e.target.value);
      this.sendTin(
        organization.tin,
        (res) => {
          if (res.ok && res.body.status) {
            toast.success(<FormattedMessage {...messages.tin_confirmed} />);
            this.props.change(`${this.props.formName}[juridical_tin]`, organization.tin);
          } else {
            toast(res.body.message || <FormattedMessage {...messages.tin_rejected} />, {
              backgroundColor: '#f2dede',
              color: '#a94442',
            });
            this.props.change(`${this.props.formName}[juridical_tin]`, '');
          }
        },
        () => this.props.change(`${this.props.formName}[juridical_name]`, organization.name)
      );
    } else {
      this.props.change(`${this.props.formName}[juridical_tin]`, '');
    }
  };

  render() {
    const { formName, isNormalForm = true } = this.props;
    const { juridicalList, checked, loading } = this.state;
    const showJuridicalList = window.user && juridicalList;

    return (
      <span>
        <div className="item business-checkbox-wrap clearfix">
          <label className={`form-label text-left ${isNormalForm ? 'col-md-3' : 'col-md-4'}`} style={{ marginTop: 15 }}>
            <FormattedMessage {...messages.entrip} />
          </label>
          <Field
            className={`${isNormalForm ? 'col-md-9' : 'col-md-8'}`}
            name={`${formName}[is_juridical]`}
            component={Checkbox}
            onChange={this.handleCheck}
            id={`${formName}-checkbox-business`}
            label={<FormattedMessage {...messages.entripHint} />}
            type="checkbox"
          />
        </div>
        {checked && (
          <Fragment>
            <div className="item clearfix" style={{ display: showJuridicalList ? 'none' : 'block' }}>
              <label
                className={`form-label text-left ${isNormalForm ? 'col-md-3' : 'col-md-5'}`}
                style={{ lineHeight: 'inherit', marginBottom: '5px' }}>
                <FormattedMessage {...messages.juridical_tin} />
              </label>
              <Field
                style={{ marginBottom: 10 }}
                forceEdit={true}
                props={{ className: isNormalForm ? 'col-md-9' : 'col-md-7' }}
                name={`${formName}[juridical_tin]`}
                component={SimpleInput}
                validate={[required, validateTin]}
                type="text"
              />
              <button
                type="button"
                className="btn btn-primary"
                onClick={this.handleClick}
                style={{ display: 'block', margin: '10px 0 0 auto', minWidth: 235 }}>
                <FormattedMessage {...messages.check_tin} /> {loading && '...'}
              </button>
            </div>
            <div className="item clearfix">
              <label
                className={`form-label text-left ${isNormalForm ? 'col-md-3' : 'col-md-5'}`}
                style={{ lineHeight: 'inherit', marginBottom: '5px' }}>
                <FormattedMessage {...messages.entripName} />
              </label>
              {showJuridicalList ? (
                <Fragment>
                  <Field
                    props={{ className: isNormalForm ? 'col-md-9' : 'col-md-7' }}
                    name={`${formName}[juridical_name]`}
                    component={SelectInput}
                    validate={[required]}
                    onChange={this.handleChange}
                    type="text">
                    <option />
                    {juridicalList.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.title}
                      </option>
                    ))}
                  </Field>
                  {loading && (
                    <div
                      style={{
                        textAlign: 'right',
                        marginTop: 10,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'flex-end',
                      }}>
                      <div style={{ margin: '0 10px' }}>
                        <FormattedMessage {...messages.check_tin} />
                        ...
                      </div>
                    </div>
                  )}
                </Fragment>
              ) : (
                <Field
                  disabled={!showJuridicalList}
                  props={{ className: isNormalForm ? 'col-md-9' : 'col-md-7' }}
                  name={`${formName}[juridical_name]`}
                  component={SimpleInput}
                  validate={[required]}
                  type="text"
                />
              )}
            </div>
          </Fragment>
        )}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/application-form/sections/entrepreneur.js